'use strict';

function MarketAnalysisDemandAdjustmentTimeOfDayBucketDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/market-analysis-demand-adjustment-time-of-day-bucket.html'),
    scope: true,
    controller: 'MarketAnalysisDemandAdjustmentTimeOfDayBucketController'
  };
}
MarketAnalysisDemandAdjustmentTimeOfDayBucketDirective.$inject = [];
module.exports = MarketAnalysisDemandAdjustmentTimeOfDayBucketDirective;